import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccountComponent } from './modules/account/account.component';
import { HomeComponent } from './modules/home/home.component';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';
import { FooterComponent } from './modules/footer/footer.component';
import { HeaderComponent } from './modules/header/header.component';
import { CaseComponent } from './modules/case/case.component';
import { ClinicVisitsComponent } from './modules/clinic-visits/clinic-visits.component';
import { ClinicalTestingComponent } from './modules/clinical-testing/clinical-testing.component';
import { DemographicsComponent } from './modules/demographics/demographics.component';
import { SickLeaveComponent } from './modules/sick-leave/sick-leave.component';
import { TravelComponent } from './modules/travel/travel.component';
import { ReportComponent } from './modules/report/report.component';
import { PortalComponent } from './modules/portal/portal.component';
import { Covid19Component } from './modules/covid19/covid19.component';
import { ConfidentialityAgreementComponent } from './modules/confidentiality-agreement/confidentiality-agreement.component';
import { SafePipe } from './safe.pipe';
import { DirectivesComponent } from './modules/directives/directives.component';
import { F621CF848DF74452Component } from './modules/f621-cf848-df74452/f621-cf848-df74452.component';
import { ImmunizationsComponent } from './modules/immunizations/immunizations.component';
import { MainComponent } from './modules/main/main.component';
import { TravelClearanceComponent } from './modules/travel-clearance/travel-clearance.component';
import { ScoConfidentialityAgreementComponent } from './modules/sco-confidentiality-agreement/sco-confidentiality-agreement.component';
import { UserGuideComponent } from './modules/user-guide/user-guide.component';

@NgModule({
  declarations: [
    AppComponent,
    AccountComponent,
    HomeComponent,
    PageNotFoundComponent,
    FooterComponent,
    HeaderComponent,
    CaseComponent,
    ClinicVisitsComponent,
    ClinicalTestingComponent,
    DemographicsComponent,
    SickLeaveComponent,
    TravelComponent,
    ReportComponent,
    PortalComponent,
    Covid19Component,
    ConfidentialityAgreementComponent,
    SafePipe,
    DirectivesComponent,
    F621CF848DF74452Component,
    ImmunizationsComponent,
    MainComponent,
    TravelClearanceComponent,
    ScoConfidentialityAgreementComponent,
    UserGuideComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
